export default "__VITE_ASSET__Cd0qrzG8__"